<script>

    // imports
    import model from '../../stores/modelStore';
	import { isValid, validator } from "../../validation";
    import { registerPageComplete } from '../../gtm';


    import Form from '../../components/Form.svelte';
    import FormRow from '../../components/FormRow.svelte';
    import FormColumn from '../../components/FormColumn.svelte';
    import DropZone from "../../components/DropZone.svelte";
    import PageSection from '../../components/PageSection.svelte';
    import NavigationButtons from '../../components/NavigationButtons.svelte';

    import Vehicle from "../../components/Vehicle.svelte";

    import VehicleModel from "../../models/Vehicle";

    // props
    export let persistUrl = null;
    export let pageTitle = null;
    export let disabled = false;
    export let lastVisitedPage = null;
    export let title = null;
    export let gtmPhase = null;

    const id = 'bulkClaimfileUploader';
    const dropZoneOptions = {
            url: "/api/file-upload?token=" + $model.registrationToken,
            acceptedFiles: "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            fileUploadToken: $model.bulkClaimDocumentList
        };

    let buttons = null;

    // component state updating
    if (!disabled) {
        $model.lastPageVisited = lastVisitedPage;
        document.title = pageTitle;
    }

    if ($model && $model.vehicles && $model.vehicles.length < 1 && !disabled)
    {
        // ONLY occurs when editing, NOT when REVIEWING 
        $model.vehicles = [new VehicleModel()];
    }

    let liveDisabled = false;
    let liveIndex = 0;
    let liveVehicle = null;
    let showBulkClaimUpload = $model.bulkVehicleClaim;

    $: {
        liveVehicle = $model.vehicles[liveIndex];
    }

    const validateForm = () => {
        let errors = [...isValid()];

		if (!errors.length) {
            return true;
        } else {
			errors[0].scrollIntoView({ behavior: "smooth" });
            return false;
		}
    }

    const handleSubmit = async (e) => {
    	buttons.blockNext();
        
		if (validateForm()) {

            // Either have vehicles or bulk added vehicles
            if ($model.bulkVehicleClaim){
                $model.vehicles = [];
                liveVehicle = null;
            }

			let response = await model.saveModelAsync(persistUrl);

			if (!response.success) {
				console.log(displayError)
			} else {
                registerPageComplete(title, gtmPhase);
				buttons.next();
			}
		}

		buttons.unblock();
    };
   

    const addBulkClaim = () => {
        showBulkClaimUpload = true;
    };
   

    const addVehicle = () => {
        if (validateForm()) {
            let newVehicleModel = new VehicleModel()
            $model.vehicles = [...$model.vehicles, newVehicleModel];
            liveIndex = $model.vehicles.length - 1;
        } 
    }

    const deleteProperty = async (index) => {
        if (confirm(`Please confirm Delete Vehicle ${index + 1}`)) {

            if (liveIndex === index) liveIndex = 0;
            else if (liveIndex > index) liveIndex -= 1;

            $model.vehicles = [...$model.vehicles.filter((_, i) => i !== index)];
        }
    }

    const setLiveProperty = async (index, disabled) => {
        if (validateForm()) {
            showBulkClaimUpload = false;
            $model.bulkVehicleClaim = false;
            $model.bulkClaimDocumentList.length = 0;

            liveIndex = index;
            $validator.clearAllVisualError(document.querySelector('form'));
        }
    }

    $: {
        if ($model.bulkClaimDocumentList.length && !$model.bulkVehicleClaim) {
            $model.bulkVehicleClaim = true;
        } else if (!$model.bulkClaimDocumentList.length && $model.bulkVehicleClaim) {
            $model.bulkVehicleClaim = false;
        }
        //console.log($model.bulkVehicleClaim, $model.bulkClaimDocumentList.length);

        //console.log("VehicleDetails", $model);
    }

</script>

<PageSection>

{#if !disabled}
    <Form {disabled} id="form-vehicle-details" on:submit={handleSubmit}>
        <div class='row panelWrapper'>
            <div class='col-sm-3 listPanel'>
                {#each $model.vehicles as vehicle, i}

                    {@const showEdit = showBulkClaimUpload || liveIndex !== i}
                    {@const showDelete = $model.vehicles.length === 1}

                    <div class='listPanelItem'>
                        <p class='listPanelItemName'>{`Vehicle ${i + 1}`}</p>
                        <span class='listPanelButtonWrapper'>
                            <button href="Edit" title="Edit Vehicle" class="action" style={`visibility: ${showEdit ? 'visible' : 'hidden'}`} on:click|preventDefault="{()=> setLiveProperty(i)}"><i class="fas fa-edit"></i></button>
                            <button href="Delete" title="Delete Vehicle" class="action" style={`visibility: ${showDelete ? 'hidden' : 'visible'}`} on:click|preventDefault="{()=> deleteProperty(i)}"><i class="fas fa-trash"></i></button>
                        </span>
                    </div>
                {/each}

                {#if !disabled}
                    <button class="btn btn-primary btn-sm mt-3"
                        title="Add another vehicle"
                        on:click|preventDefault="{()=> addVehicle()}"
                        disabled={showBulkClaimUpload}>Add another vehicle</button>
                    <button class="btn btn-primary btn-sm mt-3"
                        title="Add bulk vehicle claim"
                        on:click|preventDefault="{()=> addBulkClaim()}">Add bulk vehicle claim</button>
                {/if}
            </div>

            {#if showBulkClaimUpload}
                <FormColumn>
                    <h2>Bulk vehicle claim upload</h2>
                    <p>
                        If you have a claim for five (5) or more vehicles, please download the bulk vehicle claim spreadsheet
                        <a href="/Documents/ToyotaFleetUploadSheet.xlsx" target="_blank">here</a>
                        and upload it below once complete.
                    </p>
                    <DropZone options={dropZoneOptions}
                        {id}
                        {disabled}
                        message="<b>Upload files for your registration</b><br>Drag files here or click to upload"
                        bind:documentList={$model.bulkClaimDocumentList}></DropZone>
                </FormColumn>
            {:else}
                <FormColumn>
                    <h2>Vehicle details</h2>
                    <p>
                        The  following sections are required to be completed per vehicle you purchased. If you purchased more
                        than one vehicle, when you have completed the details for your first vehicle, please select 
                        'Add another vehicle' to create a claim for each additional vehicle. If you have more than five (5) 
                        vehicles to claim for, you can complete the claim details for each vehicle using this form or 
                        alternatively you can download the bulk vehicle spreadsheet 
                        <a href="/Documents/ToyotaFleetUploadSheet.xlsx" target="_blank">here</a>. Please then upload a completed 
                        version of the bulk vehicle spreadsheet by clicking "Bulk vehicle claim".
                    </p>

                    <hr>

                    <Vehicle {disabled} bind:vehicleDetail={liveVehicle}>
                    </Vehicle>
                </FormColumn>
            {/if}
        </div>

        <FormRow class="confirmation-hide">
            <FormColumn>
                <NavigationButtons disableNext={showBulkClaimUpload && !$model.bulkVehicleClaim}
                    bind:buttons
					nextPageLabel={$model.confirmationPage ? "Confirmation" : "Next"} />
            </FormColumn>
        </FormRow>

    </Form>

{:else}

    {#if $model.bulkVehicleClaim}
        <div class="confirmation-box-shadow">
            <FormRow>
                <FormColumn>
                    <h2>Bulk vehicle claim upload</h2>
                    <DropZone options={dropZoneOptions}
                        {id}
                        {disabled}
                        message="<b>Upload files for your registration</b><br>Drag files here or click to upload"
                        bind:documentList={$model.bulkClaimDocumentList}></DropZone>
                </FormColumn>
            </FormRow>
        </div>

    {:else}

        <FormRow>
            <FormColumn>
                {#each $model.vehicles as theVehicle, i}
                    <div class='form-group confirmation-box-shadow'>
                            <h3>{`Vehicle ${i + 1}`}</h3>
                        <Vehicle name="vehicle_{i}" {disabled} bind:vehicleDetail={theVehicle}>
                        </Vehicle>
                    </div>
                {/each}
            </FormColumn>
        </FormRow>

    {/if}
{/if}
</PageSection>

<style>
    button.action {
        outline: none;
        background-color: transparent;
        border: none;
    }

    .listPanel {
        padding-top: 5px
    }

    .listPanelItem {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 2px;
    }

    .listPanelItemName {
        margin: 0;
        text-overflow: ellipsis;
        overflow: hidden;
        padding-right: 10px;
        white-space: nowrap;
    }

    .listPanelButtonWrapper { 
        white-space: nowrap;
    }

    @media only screen and (max-width: 991px) {

        .panelWrapper {
            flex-direction: column;
        }
        .listPanel {
            padding-top: 0;
            max-width: unset;
            margin-bottom: 10px;
        }

    }

    .btn-primary {
        background-color: var(--color-primary);
        border: 3px solid var(--color-primary);
    }

    

    .btn-primary:focus {
        border: 3px solid var(--color-white);
        box-shadow:  0 0 0 3px var(--color-primary);
        background-color: var(--color-primary);
        color: var(--color-white);
        outline: none;
		transition: box-shadow 0.35s, border 0.35s;
    }

    .btn-primary:focus::after {
        border-color: var(--color-white);
    }

</style>